import { Stat } from './Stat/component.tsx';
import { StatsGroup } from './StatGroup/component.tsx';
import { Stats } from './Stats/component.tsx';

const StatsComponent = Object.assign(Stats, { StatsGroup, Stat });

export { StatsComponent as Stats };
